export default "__VITE_ASSET__CGXpTujw__"